@if (file() || documentUrl) {
  <div class="file-preview bg-pays-subtle">
    <div class="row flex-nowrap align-items-center">
      <div class="col-auto pe-1">
        <img
          [ngSrc]="fileTypeIcon()"
          height="34"
          width="25"
          alt="file icon" />
      </div>
      <div class="col">
        <p class="mb-0">
          <span class="fw-semibold">
            {{ documentUrl ? 'bank_confirmation.pdf' : file()?.name }}
          </span>
          <br />
          @if (file() && !documentUrl) {
            <span class="text-muted">
              {{ file()?.size! | bytesConverter }}
            </span>
          }
        </p>
      </div>
      @if (documentUrl) {
        <div class="col-auto ms-auto pe-0">
          <a
            rel="noopener"
            target="_blank"
            class="btn btn-sm btn-light text-secondary"
            [href]="documentDownloadUrl">
            View
          </a>
        </div>
      }
      @if (!documentUrl) {
        <div class="col-auto ms-auto pe-0">
          <div class="p-1">
            <i class="text-success iconoir-check"></i>
          </div>
        </div>
      }
      <div class="col-auto">
        <button
          type="button"
          (click)="onChangeFile()"
          class="btn-action">
          <i class="pays-icon ic-bin"></i>
        </button>
      </div>
    </div>
  </div>
}
